// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"styles_sectionWrapper__Vw1CL","sideWrapper":"styles_sideWrapper__PUT6M","imageWrapper":"styles_imageWrapper__oBr_9","content":"styles_content__icbQM"};